import Modal from "./Base/Modal";
import styled from "styled-components";
import Button from "./Base/Button";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h6 {
    font-size: 1em;
  }
  .buttonWrapper {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    width: 200px;
  }
`;

const ConfirmationModal = ({ text, show, onClose, onConfirm }) => {
  return (
    <Modal show={show} onClose={onClose}>
      <Wrapper>
        <h6>{text}</h6>
        <span>Are you sure?</span>
        <div className="buttonWrapper">
          <Button secondary onClick={onClose}>No</Button>
          <Button primary onClick={onConfirm}>Yes</Button>
        </div>
      </Wrapper>
    </Modal>
  );
};

export default ConfirmationModal;
